import { render, staticRenderFns } from "./onlinePoll.vue?vue&type=template&id=5584e7ec&scoped=true&"
import script from "./onlinePoll.vue?vue&type=script&lang=js&"
export * from "./onlinePoll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5584e7ec",
  null
  
)

export default component.exports